import { normalizarData, normalizarValor } from '../../utils';

/**
 * Retorna TRUE se o array de dados se parecer com
 * um arquivo de Repasse da operadora Unica.
 */
export const detectar = (dadosArray) => {
    // Procura nas primeiras linhas para suportar tanto XLSX (onde o cabeçalho pode estar na linha 8)
    // quanto CSV (onde o cabeçalho está na linha 0).
    for (let i = 0; i < Math.min(dadosArray.length, 20); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        // Limpeza básica para lowercase, mantendo a string original para busca
        const cleanRow = linha.map(c => String(c || '').trim().toLowerCase());
        
        const hasDataRecebimento = cleanRow.some(c => c.includes('data recebimento'));
        const hasBandeira = cleanRow.some(c => c.includes('bandeira'));
        const hasModalidade = cleanRow.some(c => c.includes('modalidade'));
        const hasValor = cleanRow.some(c => c === 'valor' || c.includes('valor'));

        if (hasDataRecebimento && hasBandeira && hasModalidade && hasValor) {
            return true;
        }
    }
    return false;
};

/**
 * Processa a planilha bruta e retorna array mapeado.
 */
export const processar = (dadosArray) => {
    let idxCabecalho = -1;
    let idxData = -1;
    let idxValor = -1;
    let idxModalidade = -1;

    // 1. Encontrar a linha de cabeçalho
    for (let i = 0; i < Math.min(dadosArray.length, 20); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const cleanRow = linha.map(c => String(c || '').trim().toLowerCase());
        
        const possibleDataIdx = cleanRow.findIndex(c => c.includes('data recebimento'));
        const possibleValorIdx = cleanRow.findIndex(c => c === 'valor' || c.includes('valor'));
        const possibleModalidadeIdx = cleanRow.findIndex(c => c.includes('modalidade'));

        if (possibleDataIdx !== -1 && possibleValorIdx !== -1) {
            idxCabecalho = i;
            idxData = possibleDataIdx;
            idxValor = possibleValorIdx;
            idxModalidade = possibleModalidadeIdx;
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho Unica não encontrado.');
    }

    const repasses = [];
    
    // 2. Processar os dados
    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || linha.length === 0) continue;

        const dataStr = String(linha[idxData] || '').trim();
        // Ignorar linhas que não começam com uma data válida ou que estejam em branco
        if (!dataStr || !dataStr.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
            continue; 
        }

        const data = normalizarData(dataStr);
        let valor = null;

        const valorRaw = linha[idxValor];
        if (typeof valorRaw === 'number') {
            valor = valorRaw;
        } else {
            valor = normalizarValor(String(valorRaw || ''));
        }

        // Tipo / Modalidade para compatibilidade com o agrupamento
        let tipoStr = 'Desconhecido';
        if (idxModalidade !== -1 && linha[idxModalidade]) {
            tipoStr = String(linha[idxModalidade]).trim();
        }

        if (data && valor !== null && valor > 0) {
            repasses.push({
                linha: i + 1,
                data: data,
                valor: valor,
                dataOriginal: dataStr,
                tipo: tipoStr
            });
        }
    }

    return repasses;
};
